import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import fetchClient from 'interfaces/fetchClient';
import env from 'variables/config';

const PennylaneCallback = () => {
    const navigate = useNavigate();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (!code) {
            setStatus('error');
            setErrorMsg('Code d\'autorisation manquant dans l\'URL.');
            return;
        }

        const token = localStorage.getItem('token');
        fetchClient
            .post(
                `${env.apiUrl}/user/pennylane/exchange`,
                { code },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(() => {
                setStatus('success');
                toast.success('🎉 Pennylane connecté ! Facturation électronique activée.');
                setTimeout(() => navigate('/settings'), 2000);
            })
            .catch((err: any) => {
                const msg = err?.response?.data?.message || 'Erreur lors de la finalisation de la connexion Pennylane.';
                setStatus('error');
                setErrorMsg(msg);
                toast.error(msg);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50">
            <div className="w-full max-w-md rounded-2xl border border-gray-100 bg-white p-10 shadow-lg text-center">
                {/* Pennylane logo */}
                <div className="mb-6 flex justify-center">
                    <div className="flex items-center gap-3">
                        <div className="flex h-12 w-12 items-center justify-center rounded-xl" style={{ background: '#00B04F' }}>
                            <svg viewBox="0 0 32 32" fill="none" className="h-7 w-7">
                                <path d="M4 4h14a8 8 0 0 1 0 16H4V4Z" fill="white" />
                                <path d="M4 20h10" stroke="white" strokeWidth="3" strokeLinecap="round" />
                            </svg>
                        </div>
                        <span className="text-xl font-bold" style={{ color: '#0A2540' }}>pennylane</span>
                    </div>
                </div>

                {status === 'loading' && (
                    <>
                        <div className="mb-5 flex justify-center">
                            <svg className="h-10 w-10 animate-spin text-green-500" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                            </svg>
                        </div>
                        <h2 className="text-lg font-semibold text-gray-800">Finalisation de la connexion…</h2>
                        <p className="mt-2 text-sm text-gray-500">Nous activons votre facturation électronique, merci de patienter.</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div className="mb-5 flex justify-center">
                            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-green-100">
                                <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                        </div>
                        <h2 className="text-lg font-semibold text-green-800">Connexion réussie !</h2>
                        <p className="mt-2 text-sm text-gray-500">Votre compte Pennylane est actif. Redirection en cours…</p>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="mb-5 flex justify-center">
                            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
                                <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                        </div>
                        <h2 className="text-lg font-semibold text-red-700">Échec de la connexion</h2>
                        <p className="mt-2 text-sm text-gray-500">{errorMsg}</p>
                        <button
                            onClick={() => navigate('/settings')}
                            className="mt-6 rounded-xl bg-gray-800 px-6 py-2.5 text-sm font-semibold text-white hover:bg-gray-700 transition-colors"
                        >
                            Retour aux paramètres
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default PennylaneCallback;
